// extracted by mini-css-extract-plugin
export default {"backAnchor":"BankTransactionDetailView_backAnchor__WCrpY","backAnchorIcon":"BankTransactionDetailView_backAnchorIcon__i1hEZ"};